<template>
  <transition name="custom-modal">
    <div class="modal__mask" :class="classList" @click.self="clickOutside">
      <div class="modal__wrapper">
        <div
          class="modal__container"
          :style="{ width: width, 'max-width': width }"
          :class="[
            { 'without-shadow': withoutShadow },
            { 'refer-modal-background': referBackground },
            { 'border-top-success': borderTopSuccess },
            { 'bg-white': isWhite },
            { 'casino-search__container': casinoSearchContainer },
          ]"
        >
          <span v-if="closeIconNew" class="close-icon-new" @click="$emit('close')">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
              <rect
                width="1.73753"
                height="18.7617"
                rx="0.868766"
                transform="matrix(0.690171 -0.723646 0.685263 0.728296 0.757812 1.25732)"
                fill="#747474"
              />
              <rect
                width="1.73231"
                height="18.7583"
                rx="0.866156"
                transform="matrix(0.68772 0.725976 -0.68772 0.725976 12.9004 0)"
                fill="#747474"
              />
            </svg>
          </span>
          <span v-else>
            <span class="modal__close" v-if="closeable" @click="$emit('close')">
              <span>
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 5.16144L12.1771 0.484331C12.8229 -0.161444 13.8699 -0.161444 14.5157 0.484331C15.1614 1.13011 15.1614 2.17711 14.5157 2.82289L9.83855 7.5L14.5157 12.1771C15.1614 12.8229 15.1614 13.8699 14.5157 14.5157C13.8699 15.1614 12.8229 15.1614 12.1771 14.5157L7.5 9.83855L2.82289 14.5157C2.17711 15.1614 1.13011 15.1614 0.484331 14.5157C-0.161444 13.8699 -0.161444 12.8229 0.484331 12.1771L5.16144 7.5L0.484331 2.82289C-0.161444 2.17711 -0.161444 1.13011 0.484331 0.484331C1.13011 -0.161444 2.17711 -0.161444 2.82289 0.484331L7.5 5.16144Z"
                    fill="#747474"
                  />
                </svg>
              </span>
            </span>
          </span>
          <div :class="{ modal__header_refer: referModalHeader }">
            <div v-if="type === 'danger' || type === 'error' || type === 'success'" class="text-center mt-4">
              <img src="@/assets/images/icon_check_2.png" class="modal__icon" v-if="type === 'success'" />

              <svg
                v-if="type === 'danger' || type === 'error'"
                class="mb-2 mt-1"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 20C0 8.97193 8.97193 0 20 0C31.0281 0 40 8.97193 40 20C40 31.0281 31.0281 40 20 40C8.97193 40 0 31.0281 0 20Z"
                  fill="#ED6706"
                />
                <path
                  d="M20 23C20.6196 23 21.1353 22.484 21.1875 21.8129L21.993 11.3559C22.0399 10.7494 21.8507 10.1498 21.472 9.70206C21.0937 9.25484 20.5595 9 20 9C19.4405 9 18.9063 9.25484 18.528 9.70206C18.1492 10.1498 17.9601 10.7494 18.007 11.3559L18.8125 21.8129C18.8647 22.484 19.3804 23 20 23Z"
                  fill="white"
                />
                <path
                  d="M20 25C18.8953 25 18 25.8952 18 27.0001C18 28.1048 18.8953 29 20 29C21.1047 29 22 28.1048 22 27.0001C22 25.8952 21.1047 25 20 25Z"
                  fill="white"
                />
              </svg>
            </div>
            <div v-if="referModalHeader" style="text-align: center;">
              <span class="general-modal-description">{{ $t('ReferView.TagFriendTitle') }}</span>
            </div>
            <slot name="header"></slot>
          </div>
          <div
            class="modal__body"
            :class="[
              { modalYScroll: modalYScroll },
              { modal__body_refer: modalBodyRefer },
              { modal__body_info: modalBodyInfo },
            ]"
          >
            <slot name="body"></slot>
            <div v-if="iframe" class="iframe-container">
              <iframe :src="iframe" style="width: 100%; height: 300px" />
            </div>
          </div>
        </div>
      </div>
      <template v-if="type && type === 'success' && $route.matched[0] && $route.matched[0].name === 'deposit'">
        <component :is="'script'">
          fbq('track', 'Purchase', {currency: "EUR", value: 0.00});
        </component>
        <!-- Twitter single-event website tag code -->
        <component :is="'script'" src="//platform.twitter.com/oct.js" type="text/javascript"></component>
        <component :is="'script'" type="text/javascript"
          >twttr.conversion.trackPid('o4rwi', { tw_sale_amount: 0, tw_order_quantity: 0 });</component
        >
        <noscript>
          <img
            height="1"
            width="1"
            style="display:none;"
            alt=""
            src="https://analytics.twitter.com/i/adsct?txn_id=o4rwi&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0"
          />
          <img
            height="1"
            width="1"
            style="display:none;"
            alt=""
            src="//t.co/i/adsct?txn_id=o4rwi&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0"
          />
        </noscript>
        <!-- End Twitter single-event website tag code -->

        <!-- Twitter single-event website tag code -->
        <component :is="'script'" src="//platform.twitter.com/oct.js" type="text/javascript"></component>
        <component :is="'script'" type="text/javascript"
          >twttr.conversion.trackPid('o4s1z', { tw_sale_amount: 0, tw_order_quantity: 0 });</component
        >
        <component :is="'script'">
          var ssaUrl = 'https://' + new Image().src; (function(d) { var syncUrl = 'https://' +
          'pixel.sitescout.com/dmp/asyncPixelSync'; var iframe = d.createElement('iframe'); iframe.src =
          "javascript:false"; d.body.appendChild(iframe); var doc = iframe.contentWindow.document; doc.open().write(`
          <body onload="window.location.href=window.syncUrl"></body>
          `); doc.close(); })(document);
        </component>
        <noscript>
          <img
            height="1"
            width="1"
            style="display:none;"
            alt=""
            src="https://analytics.twitter.com/i/adsct?txn_id=o4s1z&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0"
          />
          <img
            height="1"
            width="1"
            style="display:none;"
            alt=""
            src="//t.co/i/adsct?txn_id=o4s1z&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0"
          />
        </noscript>
        <!-- End Twitter single-event website tag code -->
      </template>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import { roundAmount } from '../../views/sports/components/bet-slip/bet-slip-utils';
import snq from 'snq';
import Cookies from 'js-cookie';

export default {
  props: [
    'type',
    'closeable',
    'classList',
    'iframe',
    'width',
    'containerClasses',
    'withoutShadow',
    'modalYScroll',
    'closeIconNew',
    'referModalHeader',
    'referBackground',
    'modalBodyRefer',
    'borderTopSuccess',
    'isWhite',
    'casinoSearchContainer',
    'outsideClickCloseable',
    'modalBodyInfo',
  ],
  computed: {
    ...mapState({
      userId: state => state.player.player.PlayerAccount,
      amount: state => state.depositStore.amount,
      depositStatus: state => state.gamecashStore.depositStatus,
    }),
    isDepositSuccessModal() {
      return this.type !== 'danger' && this.$route.matched[0] && this.$route.matched[0].name === 'deposit';
    },
    gestrkSubId() {
      return Cookies.get('gestrkSubId');
    },
    txid() {
      return snq(() => this.depositStatus.receipt.details.id) || snq(() => this.depositStatus.receipt.details[0].id);
    },
  },

  methods: {
    arkeeroEvent(adv_sub) {
      if (window.location.hostname.includes('instabet.mx')) {
        var img = document.createElement('img');
        img.src = `https://prs.arkeero.net/trk_o?adv_sub=${adv_sub}`;
        img.height = 1;
        img.width = 1;
        document.body.appendChild(img);
      }
    },
    clickOutside() {
      if (this.outsideClickCloseable) {
        this.$emit('close');
      }
    },
  },
  mounted() {
    document.body.style.overflow = 'hidden';
    if (this.isDepositSuccessModal) {
      const id = this.txid;
      console.log({ id });
      console.log({ amount: this.amount });
      this.$gestrk.postData(this.userId);
      this.arkeeroEvent(this.userId);
      this.$pixelAd.insertConversion(roundAmount(this.amount));
      /*this.$pixelAd.insertQEvent({
        qacct: 'p-YCnkxZDSh1X4A',
        labels: '_fp.event.Lead',
        orderid: this.userId,
        event: 'refresh',
      });*/
      this.$pixelAd.insertQEvent({
        qacct: 'p-YCnkxZDSh1X4A',
        labels: '_fp.event.Purchase',
        orderid: id,
        revenue: this.amount,
        event: 'refresh',
      });
      this.$pixelAd.insertGestrkScript(this.gestrkSubId, this.txid);
    }
    this.$emit('mounted');
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto';
  },
};
</script>

<style lang="scss" scoped>
@import '../../sass/variables';
@import '../../sass/mixins/_mixins';

.modal__mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  min-height: -moz-available; /* WebKit-based browsers will ignore this. */
  min-height: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
  min-height: fill-available;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal__wrapper {
  display: flex;
  max-height: 80%;
}

.modal__container {
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 250px;
  max-width: 410px;
  margin: 0px auto;
  background-color: $color-4;
  transition: all 0.3s ease;
  padding: 15px;
  color: $textColor-9;
  position: relative;
  &.without-shadow {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
  &.refer-modal-background {
    background-color: #ffffff !important;
    padding: 0px;
    overflow-y: hidden;
    &::after {
      border: 0 !important;
    }
  }
  &.border-top-success {
    padding-bottom: 20px !important ;
    border-radius: 4px;
  }
  @media (min-width: 768px) {
    justify-content: flex-start;
    border-radius: 8px;
    max-height: 80vh;
    min-width: 555px;
  }
  &.casino-search__container {
    @media (min-width: 768px) {
      justify-content: flex-start;
      border-radius: 8px;
      min-height: 80vh;
      max-height: 80vh;
      min-width: 750px;
      padding: 25px;
    }

    &::after {
      border: unset !important;
    }
  }

  .icon {
    color: $textColor-9 !important;
  }

  .modal__lg & {
    width: 70%;
  }
}

.modal__header {
  @media (max-width: 768px) {
    .modal__icon {
      width: 50px;
      height: 50px;
    }
  }
}

.modal__body {
  margin: 20px 0;

  @media (max-width: 767px) {
    h1,
    h2,
    h3 {
      font-size: 1rem;
    }
  }
  @media (max-width: 768px) {
    .modal__icon {
      width: 50px;
      height: 50px;
    }
  }
}

.modal__close {
  position: absolute;
  top: -20px;
  right: -20px;
  width: 40px;
  height: 40px;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  cursor: pointer;

  svg {
    fill: $textColor-9;
  }

  @media only screen and (max-width: 767px) {
    & {
      width: 28px;
      height: 28px;
      top: 13px;
      right: 13px;
      box-shadow: none;
    }
  }
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal__container,
.modal-leave-active .modal__container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal__icon {
  width: 50px;
  height: 50px;
}

@media only screen and (max-width: 767px) {
  .modal__container {
    min-width: 100% !important;
    height: 100% !important;
    width: 100% !important;
    justify-content: flex-start;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    margin: auto;
    overflow-y: scroll;
    padding-bottom: 50px;

    &::after {
      border: 1px solid #a6a6a6;
      content: '';
      border-radius: 4px;
      position: absolute;
      left: 6px;
      right: 6px;
      top: 6px;
      bottom: 6px;
      z-index: -1;
    }

    &.border-top-success {
      height: auto !important;
      top: 25% !important;
      padding-bottom: 15px !important;
      max-width: none !important;
      min-width: auto !important;
      width: 94% !important;
      left: 3%;
      border-radius: 4px;
    }
  }
}

@media (max-width: 540px) {
  .statsModal .modal__container {
    min-width: auto;
    margin-left: 0;
    width: 100vw !important;

    &.border-top-success {
      height: auto !important;
      top: 25% !important;
      padding-bottom: 15px !important;
      max-width: none !important;
      min-width: auto !important;
      width: 94% !important;
      left: 3%;
      border-radius: 4px;
    }
  }
  .confirmation-modal {
    .modal__container {
      padding: 0 !important;
      margin: 0;
      background: #fff;
    }

    .modal__header {
      margin: 50px 0 0;
      padding: 10px 0 0;
    }

    .modal__body {
      width: 100%;
      height: 100%;
      background: #fff;
      overflow: hidden;
      margin: 0;

      h2 {
        color: $active-color;
        font-weight: bold;
        font-size: 1rem;
        margin: 22px 0 18px;
        text-align: left !important;
        padding-left: 10px;
      }
    }

    .rows-wrapper {
      height: calc(100% - 200px);
      max-height: none;
      box-shadow: none;

      > div {
        height: 100%;
      }

      .rows {
        max-height: 100%;
      }
    }

    .confirmation-wrapper {
      height: 100%;
      display: flex;
      flex: 1;
      flex-direction: column;

      .bet-slip-button-area {
        margin: auto 0 0 0;
        padding: 10px;
      }
    }

    .bet-slip-button-area {
      .text-uppercase {
        font-size: 18px;
      }
    }
  }
}

.modalYScroll {
  overflow-x: hidden;
  overflow-y: auto;
}

.close-icon-new {
  cursor: pointer;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 13px;
  top: 8px;
  width: 28px;
  height: 28px;
  border-radius: 100%;
  margin-top: 3px;
  .icon {
    font-size: 16px;
  }
}

.general-modal-description {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  color: #404042;
}

.modal__header_refer {
  padding: 16px 15px 13px 15px;
  background: #ffffff;
}

.modal__body_refer {
  padding: 0 20px 20px 20px;
  margin: 0px !important;
}

.modal__header:empty {
  display: none !important;
}

.background-color-white {
  background-color: #ffffff;
}

.modal__body_info {
  margin: 0 20px !important;
  .modal__icon {
    margin-top: 16px !important;
  }
}
</style>
